import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Box } from '@primer/react';

var LTBox = function LTBox(_a) {
  var styles = _a.styles,
    children = _a.children,
    rest = __rest(_a, ["styles", "children"]);
  return /*#__PURE__*/React.createElement(Box, __assign({
    sx: __assign({}, styles)
  }, rest), children);
};

export { LTBox as default };
